export default "__VITE_ASSET__50b1b9fd__"